import { useProducts } from "hooks/useProducts";
import { reportStepMetadata } from "util/reportStepMetadata";
import { StepperPageHeader } from "./Report/StepperPageHeader";
import { ReportingFacilityChemicalTable } from "./ReportingFacilityChemical/ReportingFacilityChemicalTable";

export type ChemicalSummaryTableProps = {
  facilityId: string;
  reportId?: string;
};

export function ChemicalSummaryTable({
  facilityId,
  reportId,
}: ChemicalSummaryTableProps) {
  const { hasProducts } = useProducts();

  return (
    <>
      <StepperPageHeader
        header={reportStepMetadata.CHEMICAL_SUMMARY.title}
        description={reportStepMetadata.CHEMICAL_SUMMARY.getOverviewDescription(
          { hasProducts }
        )}
      />
      <ReportingFacilityChemicalTable
        facilityId={facilityId}
        reportId={reportId}
      />
    </>
  );
}
